import React from 'react';
import { derailmentsIcons } from './icons';
import classNames from 'classnames';
import { TOXICS_HIGH_RISK_SCORE } from '../../constants';

import style from './style/index.scss';

/**
 *
 * @param {Object} props - props
 * @param {string} props.scaleHandle - scale handle
 * @param {number} props.score - score
 * @param {string} [props.className] - icon container class name
 *
 * @returns {JSX.Element} - icon
 */
export function ToxicsIcon(props) {
    const { scaleHandle, score } = props;

    const SvgIcon = derailmentsIcons[scaleHandle];

    if (!SvgIcon) {
        return null;
    }

    const className = classNames(style.derailmentIcon__container, props.className, {
        [style.high]: score === TOXICS_HIGH_RISK_SCORE,
        [style.veryHigh]: score > TOXICS_HIGH_RISK_SCORE
    });

    return (
        <SvgIcon className={className} />
    );
}

ToxicsIcon.defaultProps = {
    className: ''
};
